const floatContainers = document.querySelectorAll('.FormTextbox');

if (floatContainers !== null && floatContainers !== undefined) {
    floatContainers.forEach(function(float) {

        let floatInput = float.querySelector('.FormTextbox__Input');

        float.addEventListener('click', function () {
            this.classList.add('active');
        });

        floatInput.addEventListener('blur', function (e) {
            if (!floatInput.value) {
                e.target.parentNode.classList.remove('active');
            }
        });
    });
}

const inputFocus = document.querySelectorAll('.FormTextbox__Input');

if (inputFocus !== null && inputFocus !== undefined) {
    inputFocus.forEach(function(inputs) {

        inputs.addEventListener('focus', function (e) {
            e.target.parentNode.classList.add('active');
        });
        
        if (inputs.value.length !== 0) {
            inputs.parentNode.classList.add('active');
        }
        
    });
}

const selectOption = document.querySelectorAll('select');
// Change color of select value
if (selectOption !== null && selectOption !== undefined) {

    selectOption.forEach(function(select) {
        select.addEventListener('change', function () {
            this.style.color = '#333333';
        });
    });
}